import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { EMPTY, Observable, Subject, timer } from 'rxjs';

import { TipoMensagem } from '../_classes/enum/tipo_mensagem';
import { Mensagem } from '../_classes/mensagem';
import { ServidorSrh2 } from '../_classes/servidor-srh2';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Servidor } from './../_classes/servidor';
import { EnvService } from './env.service';
import { MensagemService } from './mensagem.service';
import { RestService } from './rest.service';
import { Retorno } from '../_classes/retorno';
import { NotificacaoService } from './notificacao.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ServidorService {
  //private servidorAtual: Servidor = null;

  public servidorSrh2$: Observable<ServidorSrh2>;
  private erros$ = new Subject<boolean>();
  private emissorServidor$ = new Subject<Servidor>();
  //private carregandoServidor = false;

  //public static estaCarregadoServidor: boolean; // = false;

  constructor(
    public rest: RestService,
    private readonly _kcS: KeycloakService,
    private _sN: NotificacaoService,
    private router: Router,
    private alertService: ModalAlertaService,
    private _sEnv: EnvService,
    private mensagemService: MensagemService //private persister: PersistanceService, //private menuService: MenuService, //private router: Router
  ) {}

  estaCarregadoServidor(): boolean {
    let retorno: boolean = false;
    if (this._sEnv.servidor) {
      if (
        this._sEnv.servidor.idServidor &&
        this._sEnv.servidor.idServidor > 0
      ) {
        retorno = true;
      }
    }

    return retorno;
  }

  alterarServidor(s: Servidor, f?: () => any) {
    if (s !== this._sEnv.servidor) {
      this._sEnv.servidor = new Servidor(s);
      EnvService.servidor2 = new Servidor(s);
      this.emissorServidor$.next(s);
    }
    if (f) {
      f();
    }
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
  /*

  getServidorComFuncao(f: () => any) {
    let userDetails =
      this._kcS.getKeycloakInstance().tokenParsed.preferred_username;

    if (
      (!this.env.servidor || !this.env.servidor.servidorSrh2) &&
      !this.carregandoServidor
    ) {
      this.carregandoServidor = true;
      this.rest.getServidor(userDetails.toUpperCase()).subscribe(
        (x: Servidor) => {
          this.servidorSrh2$ = this.rest.getServidorSrh2(x.nrMatricula);
          this.servidorSrh2$.subscribe(
            (a) => {
              if (x) {
                x.servidorSrh2 = new ServidorSrh2(a);
                this.alterarServidor(x, f());
                this.carregandoServidor = false;
              }
            },
            (e) => {
              this.registrarErro('Erro ao buscar dados do servidor');
              this.carregandoServidor = false;
              return EMPTY;
            }
          );
        },
        (e) => {
          this.carregandoServidor = false;
          this.handleError(
            e +
              'Erro ao tentar conectar (' +
              this._kcS.getUsername().toLocaleUpperCase() +
              ') (keycloak) '
          );
        }
      );
    } else {
      f();
    }
  }*/

  getServidorComFuncao2(): Promise<void> {
    return new Promise((resolve, reject) => {
      let userDetails =
        this._kcS.getKeycloakInstance().tokenParsed.preferred_username;

      if (!this._sEnv.servidor || !this._sEnv.servidor?.servidorSrh2) {
        this.rest.getServidor(userDetails.toUpperCase()).subscribe(
          (x: Servidor) => {
            this.servidorSrh2$ = this.rest.getServidorSrh2(x.nrMatricula);
            this.servidorSrh2$.subscribe(
              (a) => {
                if (x) {
                  x.servidorSrh2 = new ServidorSrh2(a);
                  this.alterarServidor(x, null);
                }
                //if (!this._sEnv.notificacaoIgnorou) {
                this._sN
                  .listarNotificacoesMinhasNaoRespondidas(x.nrMatricula)
                  .subscribe({
                    next: (xNotif: Retorno) => {
                      if (
                        xNotif &&
                        xNotif.resultado &&
                        xNotif.resultado.length !== 0
                      ) {
                        this._sEnv.servidor = new Servidor(x);
                        this._sEnv.mostrarMenu = false;
                        this.router.navigate(['/notificacao-mostrar']);
                      } else {
                        this._sEnv.mostrarMenu = true;
                      }
                      this.alterarServidor(x, null);
                    },

                    error: (e: any) => {
                      this.handleError(e.message);
                      return EMPTY;
                    },
                    complete: () => {
                      resolve();
                    },
                  });
                //}
              },
              (e) => {
                this.registrarErro('Erro ao buscar dados do servidor');
                reject();
                return EMPTY;
              }
            );
          },
          (e) => {
            this.handleError(
              e +
                'Erro ao tentar conectar (' +
                this._kcS.getUsername().toLocaleUpperCase() +
                ') (keycloak) '
            );

            reject();
          }
        );
      } else {
        resolve();
      }
      // Após a conclusão da lógica, chame resolve() para indicar sucesso
    });
  }

  getServidorComFuncaoBuscandoNotificacaoOK(): Promise<void> {
    return new Promise((resolve, reject) => {
      let userDetails =
        this._kcS.getKeycloakInstance().tokenParsed.preferred_username;

      if (!this._sEnv.servidor || !this._sEnv.servidor?.servidorSrh2) {
        this.rest.getServidor(userDetails.toUpperCase()).subscribe(
          (x: Servidor) => {
            this.servidorSrh2$ = this.rest.getServidorSrh2(x.nrMatricula);
            this._sN
              .listarNotificacoesMinhasNaoRespondidas(x.nrMatricula)
              .subscribe({
                next: (xNotif: Retorno) => {
                  this.servidorSrh2$.subscribe(
                    (a) => {
                      if (x) {
                        x.servidorSrh2 = new ServidorSrh2(a);
                        if (
                          xNotif &&
                          xNotif.resultado &&
                          xNotif.resultado.length !== 0
                        ) {
                          this._sEnv.servidor = new Servidor(x);
                          this._sEnv.mostrarMenu = false;
                          this.router.navigate(['/notificacao-mostrar']);
                        } else {
                          this._sEnv.mostrarMenu = true;
                        }
                        this.alterarServidor(x, null);
                      }
                      resolve();
                    },
                    (e) => {
                      this.registrarErro('Erro ao buscar dados do servidor');
                      reject();
                      return EMPTY;
                    }
                  );
                },
                error: (e: any) => {
                  this.handleError(e.message);
                  return EMPTY;
                },
                complete: () => {},
              });
          },
          (e) => {
            this.handleError(
              e +
                'Erro ao tentar conectar (' +
                this._kcS.getUsername().toLocaleUpperCase() +
                ') (keycloak) '
            );

            reject();
          }
        );
      } else {
        resolve();
      }
      // Após a conclusão da lógica, chame resolve() para indicar sucesso
    });
  }

  getServidor() {
    return this.emissorServidor$.asObservable();
  }

  /*
  getServidorSemSerObservable(): Servidor {
    return this.env.servidor; //this.servidorAtual;
  }

  getServidorAtualSemRedirecionar(y): Servidor {
    //console.log('GetSErvidorAtualSEMRedirecionar: ' + y);
    return this.env.servidor; // this.getServidorAtualOriginal(false);
  }

  getServidorAtualRedirecionando(x): Servidor {
    //console.log('GetSErvidorAtualRedirecionando: ' + x);
    return this.env.servidor; //this.getServidorAtualOriginal(true);
  }*/

  private registrarErro(msg: string) {
    let m = new Mensagem();
    m.tipo = TipoMensagem.ERRO;
    m.mensagem = msg;
    this.mensagemService.registrarMensagem(m);
  }
}
